require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./authors-mark-gilmore.json") })
        }
      }, "path---authors-mark-gilmore");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---authors-mark-gilmore!./.cache/json/authors-mark-gilmore.json
// module id = 1312
// module chunks = 231608221292675